import { createContext } from 'react';
import { USER_LOGIN, USER_LOGOUT, LOADING_OFF, LOADING_ON } from './types';

export const initialUserData = {
  currentUser: {
    profileImage: '',
    coverImage: '',
    posts: [],
    likes: [],
    comments: [],
    followers: [],
    following: [],
    uid: '',
    fullName: '',
    email: '',
  },
  isLoading: false,
};

export const UserContext = createContext(initialUserData);

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case USER_LOGIN: {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          profileImage: payload.role,
          coverImage: payload.image,
          posts: payload.posts,
          likes: payload.likes,
          comments: payload.comments,
          followers: payload.followers,
          following: payload.following,
          uid: payload._id,
          fullName: payload.fullName,
          email: payload.email,
        },
      };
    }

    case USER_LOGOUT: {
      return {
        ...state,
        currentUser: {
          ...initialUserData,
        },
      };
    }

    case LOADING_ON: {
      return { ...state, isLoading: true };
    }

    case LOADING_OFF: {
      return { ...state, isLoading: false };
    }
  }
};
